import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { DocumentSignatureActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';

@Injectable()
export class DocumentSignatureEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService
  ) {}

  private common = new Common();

  getDocumentSignature$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentSignatureActions.getDocumentSignature),
      switchMap((action) =>
        this.onboardingProductsService.getDocumentSignature(action.request).pipe(
          map((res) => this.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            DocumentSignatureActions.getDocumentSignatureSucess({ response: res })
          ),
          catchError((error) =>
            of(
              DocumentSignatureActions.getDocumentSignatureError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );

  responseInterpreter(res) {
    console.log('******** ResponseInterpreter Input', res);
    res = res['response'];
    const response = res;
    if (
      _.get(res, 'status.code', '') === 200 ||
      _.get(res, 'status.code', '') === 202
    ) {
      if (_.get(res, 'middleware', null)) {
        response['middleware'] = _.get(res, 'middleware', null);
      }
    }
    console.log('******** ResponseInterpreter Return', response);
    return response;
  }
}
